module.exports = __webpack_public_path__ + "img/luggage_480.67b81415.png";